import { transformSummary } from "./utils";

interface ArticleSummaryProps {
  summary: string | null;
}

const FeedArticleSummary: React.FC<ArticleSummaryProps> = ({ summary }) => {
  const paragraphs = transformSummary((summary ?? "").trim());

  return (
    <div className="flex gap-1 flex-col relative -mb-0.5">
      <b className="uppercase leading-4">Summary</b>
      <div
        className="line-clamp-6 wrap-break-word text-gray-900"
        title={summary ?? ""}
      >
        {paragraphs.map((paragraph) => (
          <p key={paragraph} className="mt-0">
            {paragraph}
          </p>
        ))}
      </div>
    </div>
  );
};

export default FeedArticleSummary;
